import useWhitelableOrganizationQuery from 'hooks/useWhitelableOrganizationQuery';
import { useTranslation } from 'react-i18next';
import { CgProfile } from 'react-icons/cg';
import { useParams } from 'react-router-dom';

import { ContentCard } from '../../layout/ContentCard';
import WhiteLabelForm from './WhiteLabelForm';

const WhiteLableFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const wloId = Number(id);

  const whitelableOrganiztionQuery = useWhitelableOrganizationQuery(wloId);

  return (
    <ContentCard
      header={t(`pages:whitelabel_organizations.${id ? 'update' : 'create'}`)}
      maxWidth={{ base: 'full', xl: '75%' }}
      icon={<CgProfile size="40" />}
      isLoading={whitelableOrganiztionQuery.isLoading || whitelableOrganiztionQuery.isFetching}
    >
      <WhiteLabelForm
        wloId={wloId}
        defaultValues={{
          name: whitelableOrganiztionQuery.data?.name,
          domain: whitelableOrganiztionQuery.data?.domain,
          logo_url: whitelableOrganiztionQuery.data?.logo_url,
          auth0_org_id: whitelableOrganiztionQuery.data?.auth0_org_id,
          auth0_connection_id: whitelableOrganiztionQuery.data?.auth0_connection_id,
        }}
      />
    </ContentCard>
  );
};

export default WhiteLableFormPage;
